import { Navigate, Outlet } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const ProtectedRoute = () => {
  const isLoggedIn = (): boolean => {
    const jwt = secureLocalStorage.getItem("jwt");
    return !!jwt; // Return true if jwt is not null or undefined
  };

  return isLoggedIn() ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
